import axios from "axios";
import { useEffect, useState } from "react";
import { RiMailSendLine } from "react-icons/ri";
import StatCard from "./stat_card";

const CardThree = ({ user }) => {
	const [stats, setStats] = useState({ totalCount: 0 });
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		fetchUserStats();
	}, []);

	const fetchUserStats = async () => {
		try {
			const response = await axios.get(
				`${process.env.REACT_APP_API_URL}/api/v1/send-requests/user-stats`,
				{
					headers: {
						Authorization: `Bearer ${user.token}`,
					},
				}
			);
			const data = await response.data.data;
			setStats(data);
		} catch (error) {
			console.error("Failed to fetch user statistics:", error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<StatCard
			icon={<RiMailSendLine />}
			label="Total Requests"
			value={stats.totalCount}
			loading={loading}
			accentBg="bg-amber-50"
			accentText="text-amber-600"
			accentBar="from-amber-500 to-amber-400"
		/>
	);
};

export default CardThree;
